import type { CompteRenduPdf } from './compte-rendu-pdf'
import type { DevisPdf } from './devis-pdf'
import type { DemandePdf, ReponsePdf } from './pdf.worker'
import type { SituationPdf } from './situation-pdf'

// Génération du PDF dans un Web Worker : l'interface reste fluide même pour un
// devis de plusieurs pages. Un seul worker, créé à la première demande.

let worker: Worker | null = null
let prochainId = 1
const enCours = new Map<number, { resoudre: (b: Blob) => void; rejeter: (e: Error) => void }>()

function obtenirWorker(): Worker {
  if (!worker) {
    worker = new Worker(new URL('./pdf.worker.ts', import.meta.url), { type: 'module' })
    worker.onmessage = ({ data }: MessageEvent<ReponsePdf>) => {
      const attente = enCours.get(data.id)
      enCours.delete(data.id)
      if (!attente) return
      if ('pdf' in data) attente.resoudre(new Blob([data.pdf], { type: 'application/pdf' }))
      else attente.rejeter(new Error(data.erreur))
    }
    worker.onerror = (e) => {
      // Worker inutilisable (chargement impossible) : on échoue tout et on en recréera un
      for (const { rejeter } of enCours.values()) rejeter(new Error(e.message || 'worker PDF indisponible'))
      enCours.clear()
      worker?.terminate()
      worker = null
    }
  }
  return worker
}

function demander(contenu: Omit<DemandePdf, 'id'>): Promise<Blob> {
  return new Promise((resoudre, rejeter) => {
    const id = prochainId++
    enCours.set(id, { resoudre, rejeter })
    obtenirWorker().postMessage({ id, ...contenu } as DemandePdf)
  })
}

export const genererPdfDevis = (devis: DevisPdf) => demander({ devis })
export const genererPdfCompteRendu = (compteRendu: CompteRenduPdf) => demander({ compteRendu })
export const genererPdfSituation = (situation: SituationPdf) => demander({ situation })
export const genererFactureDevis = (devis: DevisPdf, xml: string, auteur: string) => demander({ factureDevis: { devis, xml, auteur } })
export const genererFactureSituation = (situation: SituationPdf, xml: string, auteur: string) => demander({ factureSituation: { situation, xml, auteur } })
